<template>
	<div>
		<spinner v-if="services.loading"/>
		<div v-if="!services.loading && services.data.length" class="idi-table services">
			<div class="idi-header">
				<div class="idi-cell">#</div>
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.description') }}</div>
				<div class="idi-cell">{{ $t('labels.general.price_by_unit') }}</div>
				<div class="idi-cell">{{ $t('labels.general.tax') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="service in services.data" :key="service.id">
				<div class="idi-cell">
					<span>{{ service.id }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ $t(serviceNamesTranslated.get(service.name)) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ service.description }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ service.monthly_price_unity }}€</span>
				</div>
				<div class="idi-cell">
					<span>{{ service.tax_percent_label }}</span>
				</div>
				<div class="idi-cell grid-area-operations">
					<span v-if="isSelected(service)">✓</span>
					<button v-else class="btn btn-round btn-small" @click="onSelected(service)">{{ $t('labels.general.select') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'services'
	],
	data () {
		return {
			selected: null,
			serviceNamesTranslated: new Map([ [ 'Rent watches', 'labels.general.rent_watches' ], [ 'Seats', 'labels.general.seats' ] ]),
		}
	},
	methods: {
		isSelected (service) {
			return this.selected === service.id
		},
		onSelected (service) {
			this.selected = service.id
			this.$emit('selected', service )
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/SubscriptionFormService.vue